class ContractTemplate {
    id = null;
    name = '';
    uploaded_file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    user_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default ContractTemplate;
